const plnFormatter = new Intl.NumberFormat("pl-PL", {
  style: "currency",
  currency: "PLN",
  currencyDisplay: "code",
});

const usdFormatter = new Intl.NumberFormat("pl-PL", {
  style: "currency",
  currency: "USD",
  currencyDisplay: "code",
});

const eurFormatter = new Intl.NumberFormat("pl-PL", {
  style: "currency",
  currency: "EUR",
  currencyDisplay: "code",
});
const gbpFormatter = new Intl.NumberFormat("pl-PL", {
  style: "currency",
  currency: "GBP",
  currencyDisplay: "code",
});
export function currency(value, curr = "PLN") {
  if (curr === "USD") {
    return usdFormatter.format(value);
  }
  if (curr === "EUR") {
    return eurFormatter.format(value);
  }
  if (curr === "GBP") {
    return gbpFormatter.format(value);
  }

  return plnFormatter.format(value);
}
